import { t } from 'i18next';
import * as Yup from 'yup';

export const addIncidentSchema = Yup.object().shape({
  incidentType: Yup.string().required(t('error_incident_type_required')),
  description: Yup.string().required(t('error_description_required')),
  locations: Yup.array().min(1).required(),
  severity: Yup.string().required(t('error_select_severity')),
  occuranceRate: Yup.string().required(t('error_select_occurance_rate')),
  rcaRequired: Yup.boolean(),
  rcaDate: Yup.string().when('rcaRequired', {
    is: true,
    then: Yup.string().required(t('error_select_either_of_above_values')),
  }),
});
